<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Invoices</h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <BaseButton
              v-if="$membershipHasPermissionTo('create invoices')"
              tag="router-link"
              :to="{ name: 'accounts.accountId.invoices.create', params: { accountId } }"
              primary
              class="ml-auto md:ml-4"
            >
              New Invoice
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
    <div class="px-4 pb-4 lg:px-12 lg:pb-12 -mt-12">
      <div class="max-w-5xl mx-auto">
        <div class="space-y-16">
          <VList :meta="meta">
            <template #before>
              <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4 pr-2">
                <div class="w-48 px-4">Issue Date</div>
                <div class="flex-1 px-4">Issuer</div>
                <div class="w-32 px-4">Number</div>
                <div class="w-32 px-4 text-right mr-12">Amount</div>
              </div>
            </template>

            <template v-if="isLoading" #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                <Loader />
              </div>
            </template>

            <template v-else-if="isRejected" #default>
              <div
                class="odd:bg-red-100 border border-red-200 rounded p-4 text-red-600 text-center"
              >
                Something went wrong. Please try again later.
              </div>
            </template>

            <template v-else-if="invoices.length" #default>
              <template v-for="invoice in invoices">
                <VListLine
                  :key="`invoices_${invoice.uuid}`"
                  :invoice="invoice"
                  :disabled="isLoading"
                  @invoice:view="viewInvoice"
                />
              </template>
            </template>

            <template v-else #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                No results found
              </div>
            </template>
          </VList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import VListVue from '@/components/Common/VList.vue';
import AccountListLineVue from '@/components/Invoices/AccountListLine.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  components: {
    VList: VListVue,
    VListLine: AccountListLineVue,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      status: STATUS_IDLE,
    };
  },

  computed: {
    ...mapGetters('ui/accountInvoices', ['invoices']),
    ...mapState('ui/accountInvoices', ['meta']),
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  async beforeRouteEnter(to, from, next) {
    const { accountId: accountUuid } = to.params;
    const { query: params } = to;

    try {
      await store.dispatch('ui/accountInvoices/load', { accountUuid, params });
      next();
    } catch (error) {
      next(false);
    }
  },

  methods: {
    viewInvoice(invoice) {
      this.$router.push({
        name: 'accounts.accountId.invoices.invoiceUuid',
        params: {
          accountId: this.accountId,
          invoiceUuid: invoice.uuid,
        },
      });
    },
  },
};
</script>
